import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function rangeValidator(min: number, max: number, isDate: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let value = control.value as string;

        if (value === null || value === undefined) {
            // Se il valore è nullo o indefinito, non eseguire la validazione
            return null;
        }

        if ((min !== null && min !== undefined) && (max === null || max === undefined)) {
            if (value.length < min) {
                // Se il valore è al di fuori del range specificato, restituisci un errore
                return { 'range': { message: `Il valore non deve essere inferiore a ${min}` } };
            }
        }

        if ((min === null || min === undefined) && (max !== null && max !== undefined)) {
            if (value.length > max) {
                // Se il valore è al di fuori del range specificato, restituisci un errore
                return { 'range': { message: `Il valore non deve essere superiore a ${max}` } };
            }
        }

        if ((min !== null && min !== undefined) && (max !== null && max !== undefined)) {
            if (value.length < min || value.length > max) {
                // Se il valore è al di fuori del range specificato, restituisci un errore
                return { 'range': { message: `Il valore deve essere compreso tra ${min} e ${max}` } };

            }
        }



        // Se il valore è nel range specificato, non ci sono errori
        return null;
    };
}


export function lessThenOrEqualValidator(ctrlValue: number, isDate: boolean, isCurrency: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let value = control.value;

        if (value === null || value === undefined) {
            // Se il valore è nullo o indefinito, non eseguire la validazione
            return null;
        }

        if (isCurrency) {
            if (value === "") {
                value = 0;
            }
            value = parseFloat(value);
        }



        if (isNaN(value)) {
            return { 'formatError': { message: `Il valore deve essere numerico` } };
        }

        if (value > ctrlValue) {
            if (isDate) {
                let date = new Date(ctrlValue);
                const day = date.getDate().toString().padStart(2, '0'); // Ottieni il giorno e aggiungi lo zero iniziale se necessario
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ottieni il mese (0-11) e aggiungi uno per ottenere il formato (1-12)
                const year = date.getFullYear();

                let dateString = `${day}/${month}/${year}`;
                return { 'lessThenOrEqualError': { message: `La data deve essere minore o uguale a ${dateString}` } };
            } else {
                // Se il valore non è un numero o è inferiore al valore minimo specificato, restituisci un errore
                let typeError = isCurrency ? "La valuta" : "Il valore";
                let errorValue = isCurrency ? formatCurrencyError(ctrlValue) : ctrlValue;
                return { 'lessThenOrEqualError': { message: `${typeError} deve essere minore o uguale a ${errorValue}` } };
            }


        }

        // Se il valore è uguale o superiore al valore minimo, non ci sono errori
        return null;
    };
}

export function greaterThenOrEqualValidator(ctrlValue: number, isDate: boolean, isCurrency: boolean): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        let value = control.value;

        if (value === null || value === undefined) {
            // Se il valore è nullo o indefinito, non eseguire la validazione
            return null;
        }

        if (isCurrency) {
            if (value === "") {
                value = 0;
            }
            value = parseFloat(value);
        }

        if (isNaN(value)) {
            return { 'formatError': { message: `Il valore deve essere numerico` } };
        }

        if (value < ctrlValue) {
            if (isDate) {
                let date = new Date(ctrlValue);
                const day = date.getDate().toString().padStart(2, '0'); // Ottieni il giorno e aggiungi lo zero iniziale se necessario
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ottieni il mese (0-11) e aggiungi uno per ottenere il formato (1-12)
                const year = date.getFullYear();

                let dateString = `${day}/${month}/${year}`;
                return { 'greaterThenOrEqualError': { message: `La data deve essere maggiore o uguale a ${dateString}` } };
            } else {
              console.log(ctrlValue)
              console.log(value)
                // Se il valore non è un numero o è inferiore al valore minimo specificato, restituisci un errore
                let typeError = isCurrency ? "La valuta" : "Il valore";
                let errorValue = isCurrency ? formatCurrencyError(ctrlValue) : ctrlValue;
                return { 'greaterThenOrEqualError': { message: `${typeError} deve essere maggiore o uguale a ${errorValue}` } };
            }

        }

        // Se il valore è uguale o superiore al valore minimo, non ci sono errori
        return null;
    };
}

export function formatCurrencyError(value: number){

  let split: string[] = value.toString().split('.');
  let decimalFixed: string = split[1] || '';

  if(decimalFixed.length < 2) decimalFixed = decimalFixed + '0';

  return `${split[0]},${decimalFixed}`;

}


export function alphabeticValidator(hasPunctuation: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            // Se il valore è nullo, indefinito o vuoto, non eseguire la validazione
            return null;
        }

        // Utilizza una regex per verificare se il valore contiene solo caratteri alfabetici
        const alphabeticPattern = hasPunctuation ? /^[a-zA-Z \p{P}]+$/u : /^[a-zA-Z ]+$/;
        if (!alphabeticPattern.test(value)) {
            return { 'alphabetic': { message: `Il valore deve essere alfabetico` } };
        }

        // Se il valore è alfabetico, non ci sono errori
        return null;
    };
}


export function numericValidator(hasPunctuation: boolean): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            // Se il valore è nullo, indefinito o vuoto, non eseguire la validazione
            return null;
        }

        // Utilizza una regex per verificare se il valore contiene solo caratteri numerici
        const numericPattern = hasPunctuation ? /^[\d \p{P}]+$/u : /^\d+$/;
        if (!numericPattern.test(value)) {
            return { 'numeric': { message: `Il valore deve essere numerico` } };
        }

        // Se il valore è numerico, non ci sono errori
        return null;
    };
}


export function currencyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            // Se il valore è nullo, indefinito o vuoto, non eseguire la validazione
            return null;
        }

        // Utilizza una regex per verificare se il valore corrisponde a un formato di valuta (ad esempio, 123.45)
        const currencyPattern = /^\d+\.\d{2}$/; // Formato: numeri.decimali
        if (!currencyPattern.test(value)) {
            return { 'currencyFormat': { message: `Il valore deve essere in formato valuta` } };
        }

        // Se il valore è nel formato corretto, non ci sono errori
        return null;
    };
}


export function urlValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (value === null || value === undefined || value === '') {
            // Se il valore è nullo, indefinito o vuoto, non eseguire la validazione
            return null;
        }

        // Utilizza una regex per verificare se il valore corrisponde a un formato di URL valido con inizio "http" o "https"
        const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
        if (!urlPattern.test(value)) {
            return { 'invalidUrlFormat': { message: `Il valore deve essere in formato url ( es : http://www.euforlegal.it )` } };
        }

        // Se il valore è un URL valido, non ci sono errori
        return null;
    };
}



function stringToCurrencyFloat(inputString: string): number {
    // Verifica se inputString è una stringa
    if (typeof inputString !== 'string') {
        return NaN; // Se non è una stringa, restituisci NaN o un valore di default
    }

    // Definisci un'espressione regolare per rilevare il formato di valuta (esempi: "€1,234.56" o "1.234,56")
    const currencyRegex = /^[-+]?\d+(\.\d{1,2}|\,\d{1,2}|\.\d{3})*$/;

    // Verifica se la stringa corrisponde al formato di valuta
    if (currencyRegex.test(inputString)) {
        // Rimuovi tutti i caratteri non numerici e sostituisci ',' con '.'
        const cleanedString = inputString.replace(/[^0-9,.]/g, '').replace(',', '.');

        // Converti la stringa pulita in un numero in virgola mobile (float)
        return parseFloat(cleanedString);
    } else {
        // Se la stringa non è nel formato di valuta, restituisci NaN o gestisci l'errore in modo appropriato
        return NaN; // oppure puoi restituire un valore di default o lanciare un'eccezione
    }
}


export function currencyStringToNumber(currencyString: string) {
    // Rimuovi tutti i caratteri non numerici tranne il punto decimale
    currencyString = currencyString.replace(/\./g, '');
    currencyString = currencyString.replace(",", ".");

   // const numericString = Number(currencyString.replace(/[^\d.]/g, ""));

    return currencyString;
    // Parsa la stringa numerica e restituisci il risultato
    //return parseFloat(numericString);
  }
